import React from 'react'
import Box from '@mui/material/Box'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import { SignInButton } from '../../SignInButton'
import './SignIn.css'
import { useTranslation } from 'react-i18next'
import 'react-block-ui/style.css'

const SignInAD = (props) => {
  // Pagina de login para usuarios internos (AAD)

  const [snackbarErrorOpen, setSnackbarErrorOpen] = React.useState(
    Boolean(props.location?.state?.authError)
  )
  const [snackbarSuccessOpen, setSnackbarSuccessOpen] = React.useState(false)
  const { t } = useTranslation()

  const handleSnackbarClose = () => {
    setSnackbarErrorOpen(false)
    setSnackbarSuccessOpen(false)
  }

  return (
    <Box className='login-box'>
      <div
        className='login-wrap'
        style={{
          backgroundImage: `url(${
            window.$brand === 'PRB' || window.$brand === 'STRATOS'
              ? '/assets/bg_PRB.png'
              : '/assets/bg_BLP.png'
          })`
        }}
      >
        <form className='login-form' action=''>
          <div className='login-form-header'>
            <Box
              component='img'
              alignItems='center'
              sx={{
                height: window.$brand === 'PRB' ? 80 : 60
              }}
              alt='Logo'
              src={
                window.$brand === 'PRB'
                  ? '/assets/legally.png'
                  : window.$brand === 'STRATOS'
                    ? '/assets/stratos.png'
                    : '/assets/BLP Micrositeazulverde.png'
              }
            />
            {window.$brand === 'BLP' && <h3>{t('Client_Portal')}</h3>}
          </div>
          <div className='login-form-footer'>
            <SignInButton history={props.history} />
          </div>
          <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={snackbarErrorOpen}
            autoHideDuration={4000}
            onClose={handleSnackbarClose}
            key={'bottomcentererror'}
          >
            <Alert elevation={6} variant='filled' severity='error'>
              {t('Invalid_credentials')}
            </Alert>
          </Snackbar>
          <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={snackbarSuccessOpen}
            autoHideDuration={4000}
            onClose={handleSnackbarClose}
            key={'bottomcentersuccess'}
          >
            <Alert elevation={6} variant='filled' severity='success'>
              {t('Welcome')}
            </Alert>
          </Snackbar>
        </form>
      </div>
    </Box>
  )
}

export default SignInAD
